export interface ICoordinates
{
    x: number;
    y: number;
}

export class Coordinates implements ICoordinates
{
    constructor (public x: number, public y: number )
    {
    }

    toString (): string
    {
        return `x: ${this.x} - y: ${this.y}`;
    }
}
